import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useUpsell } from './UpsellContext';
import { warmCheckoutConnection } from '../utils/warmCheckout';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    openUpsell
  } = useUpsell();
  useEffect(() => {
    const handleScroll = () => {
      // Appear after the user scrolls past the hero (~500px)
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Once the sticky bar shows, the user is deep enough to signal intent.
  useEffect(() => {
    if (isVisible) warmCheckoutConnection();
  }, [isVisible]);
  return <div className={`md:hidden fixed left-0 right-0 bottom-0 z-40 px-3 pointer-events-none transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
    paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))'
  }} aria-hidden={!isVisible} data-id="element-244">
      <div className="pointer-events-auto bg-cream-50/95 backdrop-blur-md border border-cream-300 rounded-2xl shadow-[0_8px_30px_-8px_rgba(31,27,22,0.18)] flex items-center justify-between gap-3 pl-4 pr-1.5 py-1.5" data-id="element-245">
        {/* Left: price + micro detail */}
        <div className="flex flex-col leading-tight min-w-0" data-id="element-246">
          <div className="flex items-baseline gap-1.5" data-id="element-247">
            <span className="font-serif text-lg font-semibold text-ink-900" data-id="element-248">
              $299
            </span>
            <span className="text-[10px] text-ink-600 font-medium uppercase tracking-wider" data-id="element-249">
              MXN
            </span>
          </div>
          <p className="text-[11px] text-ink-600 truncate" data-id="element-250">
            1,500+ soluciones · 5 ebooks · 10 bonos
          </p>
        </div>

        {/* Right: CTA */}
        <button type="button" onClick={openUpsell} onMouseEnter={warmCheckoutConnection} onTouchStart={warmCheckoutConnection} className="flex-shrink-0 inline-flex items-center gap-1.5 bg-olive-600 hover:bg-olive-700 active:scale-[0.98] text-cream-50 text-sm font-semibold py-3 px-4 rounded-xl transition-all shadow-sm" data-id="element-251">
          <span data-id="element-252">QUIERO MI BIBLIOTECA</span>
          <ArrowRight className="w-4 h-4" data-id="element-253" />
        </button>
      </div>
    </div>;
}